import type {FC} from 'react';
import React from 'react';
import logoPath from "./RBLogo.svg"

interface RBLogoProps extends LogoSwitcherProps{
    [key: string]: any;
}

interface LogoSwitcherProps {
    org?: string;
    icon?: boolean;
}

const RBLogo: FC<RBLogoProps> = (icon, props) => (
    <img
        alt="RB Logo"
        src={logoPath}
        height={props.icon ? 100 : 66}
        width={props.icon ? 200 : 60}
        style={{
            margin: 1
        }}
        {...props}
    />
);
export default RBLogo;